import { render, staticRenderFns } from "./reisetermin-card-release-process.vue?vue&type=template&id=5ae91513&scoped=true"
import script from "./reisetermin-card-release-process.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-release-process.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-release-process.vue?vue&type=style&index=0&id=5ae91513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae91513",
  null
  
)

export default component.exports